import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex flex-row-reverse" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = { class: "col-md-6 overflow-auto scrollable-container" }
const _hoisted_6 = {
  class: "btn-group mb-4",
  role: "group",
  "aria-label": "Exercise is complete"
}
const _hoisted_7 = {
  key: 0,
  class: "btn btn-success",
  for: "btncheck1"
}
const _hoisted_8 = {
  key: 1,
  class: "btn btn-secondary",
  for: "btncheck1"
}
const _hoisted_9 = { class: "card mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "card-header" }, "Preview", -1)
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "list-group" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 0,
  class: "card mb-4 mt-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "card-header" }, "Solutie", -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "col-md-6 overflow-auto scrollable-container mb-4" }
const _hoisted_21 = { id: "ExForm" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("legend", null, "Continut", -1)
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "statementField",
  class: "form-label mt-4"
}, " Enunt afisat ", -1)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "originalStatementField",
  class: "form-label mt-4"
}, " Enunt original (optional) ", -1)
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "optionsField",
  class: "form-label mt-4"
}, " Variante de raspuns ", -1)
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "drawingField",
  class: "form-label mt-4"
}, " Desen (optional) ", -1)
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "solutionField",
  class: "form-label mt-4"
}, " Solutie (optional) ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("legend", { class: "mt-5" }, "Programa", -1)
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "academicProgramField",
  class: "form-label mt-4"
}, " Profil ", -1)
const _hoisted_37 = { id: "academicProgramsDataList" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "gradeField",
  class: "form-label mt-4"
}, " Clasa ", -1)
const _hoisted_40 = { id: "gradesDataList" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "chapterField",
  class: "form-label mt-4"
}, " Capitol ", -1)
const _hoisted_43 = { id: "chaptersDataList" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "subchapterField",
  class: "form-label mt-4"
}, " Subcapitol ", -1)
const _hoisted_46 = { id: "subchaptersDataList" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("legend", { class: "mt-5" }, "Examen (optional)", -1)
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  for: "examTypeField",
  class: "form-label mt-4"
}, " Tip Examen ", -1)
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<option value=\"non\">Nespecificat</option><option value=\"bac\">Bacalaureat</option><option value=\"evn\">Evaluare Nationala</option><option value=\"lml\">Liceul Militar</option><option value=\"adf\">Admitere Facultate</option>", 5)
const _hoisted_55 = [
  _hoisted_50
]
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "subjectNumberField",
  class: "form-label mt-4"
}, " Subiect ", -1)
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  for: "exerciseNumberField",
  class: "form-label mt-4"
}, " Exercitiu ", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("legend", { class: "mt-5" }, "Proprietati", -1)
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  for: "difficultyLevelField",
  class: "form-label mt-4"
}, " Nivel de dificultate ", -1)
const _hoisted_63 = { class: "form-text text-muted" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", {
  for: "timeToSolveField",
  class: "form-label mt-4"
}, " Timp de rezolvare (minute) ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("legend", { class: "mt-5" }, "Sursa (optional)", -1)
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  for: "publishingField",
  class: "form-label mt-4"
}, " Editura ", -1)
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  for: "yearPublishedField",
  class: "form-label mt-4"
}, " Anul publicarii ", -1)
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", {
  for: "sourcePageNumberField",
  class: "form-label mt-4"
}, " Pagina, Nr. exercitiu ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiple_choice_input = _resolveComponent("multiple-choice-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveExercise && _ctx.saveExercise(...args))),
        disabled: _ctx.denyEdit
      }, " Salveaza ", 8, _hoisted_3),
      _createElementVNode("button", {
        class: "btn btn-secondary me-2",
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelButton && _ctx.cancelButton(...args)))
      }, " Anuleaza "),
      _createElementVNode("button", {
        class: "btn btn-secondary me-2",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previewPdf && _ctx.previewPdf(...args)))
      }, " Preview PDF ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck1",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isComplete.value) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.form.isComplete.value]
          ]),
          (_ctx.form.isComplete.value == true)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, "Complete"))
            : (_openBlock(), _createElementBlock("label", _hoisted_8, "In work"))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "card-text",
              innerHTML: _ctx.processMath(_ctx.form.statement.value)
            }, null, 8, _hoisted_12)
          ]),
          (_ctx.drawingPreview != '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.drawingPreview,
                class: "d-block user-select-none"
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
                  JSON.parse(_ctx.form.multipleChoiceOptions.value)
                ), (option, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i,
                  class: "list-group-item",
                  innerHTML: _ctx.processMath(option)
                }, null, 8, _hoisted_16))
              }), 128))
            ])
          ])
        ]),
        (_ctx.solutionPreview != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("iframe", {
                src: _ctx.solutionPreview,
                height: "550"
              }, null, 8, _hoisted_19)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("form", _hoisted_21, [
          _createElementVNode("fieldset", null, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.form.statement.errors.length > 0 }]),
                id: "statementField",
                rows: "4",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.statement.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.statement.value]
              ]),
              _createElementVNode("button", {
                class: "btn btn-secondary me-2 mt-2",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.btnReplaceDollarWithHashtag && _ctx.btnReplaceDollarWithHashtag(...args)))
              }, " Replace $ with # "),
              _createElementVNode("button", {
                class: "btn btn-secondary me-2 mt-2",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.btnReplaceHashtagWithDollar && _ctx.btnReplaceHashtagWithDollar(...args)))
              }, " Replace # with $ "),
              _createElementVNode("button", {
                class: "btn btn-secondary mt-2",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.btnRemoveAllHashtagAndDollar && _ctx.btnRemoveAllHashtagAndDollar(...args)))
              }, " Remove all # and $ "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.statement.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", {
                innerHTML: _ctx.processMath(_ctx.form.originalStatement.value)
              }, null, 8, _hoisted_27),
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["form-control", {
                  'is-invalid': _ctx.form.originalStatement.errors.length > 0,
                }]),
                id: "originalStatementField",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.originalStatement.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.originalStatement.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.originalStatement.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_multiple_choice_input, {
                class: _normalizeClass({
                  'is-invalid': _ctx.form.multipleChoiceOptions.errors.length > 0,
                }),
                modelValue: _ctx.form.multipleChoiceOptions.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.multipleChoiceOptions.value) = $event))
              }, null, 8, ["class", "modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.multipleChoiceOptions.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", {
                class: _normalizeClass(["input-group", { 'is-invalid': _ctx.form.drawing.errors.length > 0 }])
              }, [
                _createElementVNode("input", {
                  class: "form-control",
                  type: "file",
                  id: "drawingField",
                  accept: "image/jpeg,image/png",
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDrawingChange && _ctx.handleDrawingChange(...args))),
                  ref: "drawingInput"
                }, null, 544),
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  type: "button",
                  id: "clear-drawing",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearDrawingInput && _ctx.clearDrawingInput(...args)))
                }, " Sterge ")
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.drawing.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", {
                class: _normalizeClass(["input-group", { 'is-invalid': _ctx.form.solution.errors.length > 0 }])
              }, [
                _createElementVNode("input", {
                  class: "form-control",
                  type: "file",
                  id: "solutionField",
                  accept: ".pdf,image/jpeg,image/png",
                  onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleSolutionChange && _ctx.handleSolutionChange(...args))),
                  ref: "solutionInput"
                }, null, 544),
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  type: "button",
                  id: "clear-solution",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearSolutionInput && _ctx.clearSolutionInput(...args)))
                }, " Sterge ")
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.solution.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                id: "academicProgramField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", {
                  'is-invalid': _ctx.form.academicProgramName.errors.length > 0,
                }]),
                list: "academicProgramsDataList",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.academicProgramName.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.academicProgramName.value]
              ]),
              _createElementVNode("datalist", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.academicPrograms, (academicProgram, i) => {
                  return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(academicProgram), 1))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.academicProgramName.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                id: "gradeField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.gradeName.errors.length > 0 }]),
                list: "gradesDataList",
                onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.chaptersRefresh && _ctx.chaptersRefresh(...args))),
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.gradeName.value) = $event))
              }, null, 34), [
                [_vModelText, _ctx.form.gradeName.value]
              ]),
              _createElementVNode("datalist", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grades, (grade, i) => {
                  return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(grade), 1))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.gradeName.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                id: "chapterField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.chapterName.errors.length > 0 }]),
                list: "chaptersDataList",
                onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.chaptersRefresh && _ctx.chaptersRefresh(...args))),
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.chapterName.value) = $event))
              }, null, 34), [
                [_vModelText, _ctx.form.chapterName.value]
              ]),
              _createElementVNode("datalist", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chapters, (chapter, i) => {
                  return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(chapter), 1))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.chapterName.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _withDirectives(_createElementVNode("input", {
                id: "subchapterField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.subchapterName.errors.length > 0 }]),
                list: "subchaptersDataList",
                onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.subchaptersRefresh && _ctx.subchaptersRefresh(...args))),
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.subchapterName.value) = $event))
              }, null, 34), [
                [_vModelText, _ctx.form.subchapterName.value]
              ]),
              _createElementVNode("datalist", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subchapters, (subchapter, i) => {
                  return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(subchapter), 1))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.subchapterName.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _withDirectives(_createElementVNode("select", {
                id: "examTypeField",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.examType.errors.length > 0 }]),
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.examType.value) = $event))
              }, _hoisted_55, 2), [
                [_vModelSelect, _ctx.form.examType.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.examType.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _withDirectives(_createElementVNode("input", {
                id: "subjectNumberField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.subjectNumber.errors.length > 0 }]),
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.subjectNumber.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.subjectNumber.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.subjectNumber.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _withDirectives(_createElementVNode("input", {
                id: "exerciseNumberField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", { 'is-invalid': _ctx.form.exerciseNumber.errors.length > 0 }]),
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.exerciseNumber.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.exerciseNumber.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.exerciseNumber.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: _normalizeClass(["form-range", {
                  'is-invalid': _ctx.form.selectedLevel.errors.length > 0,
                }]),
                step: "1",
                max: "2",
                min: "0",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.selectedLevel.value) = $event)),
                id: "difficultyLevelField"
              }, null, 2), [
                [_vModelText, _ctx.form.selectedLevel.value]
              ]),
              _createElementVNode("small", _hoisted_63, _toDisplayString(_ctx.difficultyLevels[_ctx.form.selectedLevel.value]), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.selectedLevel.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _withDirectives(_createElementVNode("input", {
                id: "timeToSolveField",
                type: "number",
                min: "1",
                max: "3600",
                class: _normalizeClass(["form-control form-control-sm", {
                  'is-invalid': _ctx.form.minutesToSolve.errors.length > 0,
                }]),
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.minutesToSolve.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.minutesToSolve.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.minutesToSolve.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _withDirectives(_createElementVNode("input", {
                id: "publishingField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", {
                  'is-invalid': _ctx.form.publishing.errors.length > 0,
                }]),
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.publishing.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.publishing.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.publishing.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _withDirectives(_createElementVNode("input", {
                id: "yearPublishedField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", {
                  'is-invalid': _ctx.form.yearPublished.errors.length > 0,
                }]),
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.yearPublished.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.yearPublished.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.yearPublished.errors, (error, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "invalid-feedback"
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _withDirectives(_createElementVNode("input", {
                id: "sourcePageNumberField",
                type: "text",
                class: _normalizeClass(["form-control form-control-sm", {
                  'is-invalid': _ctx.form.sourcePageNumber.errors.length > 0,
                }]),
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.sourcePageNumber.value) = $event))
              }, null, 2), [
                [_vModelText, _ctx.form.sourcePageNumber.value]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}